import { FuseScrollbars } from '@fuse';
import { AppBar, Hidden, withStyles } from '@material-ui/core';
import Logo from 'app/Configs/fuse-layouts/shared-components/Logo';
import NavbarFoldedToggleButton from 'app/Configs/fuse-layouts/shared-components/NavbarFoldedToggleButton';
import NavbarMobileToggleButton from 'app/Configs/fuse-layouts/shared-components/NavbarMobileToggleButton';
import UserNavbarHeader from 'app/Configs/fuse-layouts/shared-components/UserNavbarHeader';
import Navigation from 'app/Core/Components/Navigation/Navigation';
import clsx from 'clsx';
import React from 'react';
import { MdArrowForward } from 'react-icons/md';

const styles = theme => ({
    content: {
        overflowX: 'hidden',
        overflowY: 'auto',
        '-webkit-overflow-scrolling': 'touch',
        background: 'linear-gradient(rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0) 30%), linear-gradient(rgba(0, 0, 0, 0.25) 0, rgba(0, 0, 0, 0) 40%)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 40px, 100% 10px',
        backgroundAttachment: 'local, scroll'
    },
    toolbarNovo: {
        backgroundColor: theme.palette.type === "dark" ? "#424242" : "#E6E6E6"
    },
});

const NavbarMobileLayout2 = ({ classes }) => {
    return (
        <div className="flex flex-col h-full overflow-hidden">
            <AppBar
                color="primary"
                position="static"
                elevation={0}
                className={clsx(classes.toolbarNovo, "flex flex-row items-center flex-shrink h-64 min-h-64 pl-20 pr-12")}
            >
                <div className="flex flex-1 pr-8">
                    <Logo />
                </div>

                <Hidden mdDown>
                    <NavbarFoldedToggleButton className="w-40 h-40 p-0" />
                </Hidden>

                <Hidden lgUp>
                    <NavbarMobileToggleButton className="w-40 h-40 p-0">
                        <MdArrowForward />
                    </NavbarMobileToggleButton>
                </Hidden>
            </AppBar>

            <FuseScrollbars className={clsx(classes.content)}>

                <UserNavbarHeader />

                <Navigation layout="vertical" />
            </FuseScrollbars>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(NavbarMobileLayout2);


